
import { faLocationArrow } from '@fortawesome/pro-solid-svg-icons'
import distance from '@turf/distance'

import { getCurrentPosition } from '~/lib/geo/currentPosition'

export default {
  name: 'PaddockFinder',

  data() {
    return {
      address: {
        fetchPostcodeApi: new this.$ApiModel(),
        postcode: null,
        error: null,
        hasLocation: false,
        addressCoordinates: []
      },

      isFetchingLocation: false,
      faLocationArrow
    }
  },

  computed: {
    compPaddocksInDistanceOrder() {
      if (this.address.addressCoordinates.length === 0) {
        return this.$store.getters['paddocks/all']
      }

      return this.$store.getters['paddocks/all']
        .map(paddock => {
          const distanceMiles = distance(this.address.addressCoordinates, paddock.entranceCoordinates, {
            units: 'miles'
          })

          return {
            ...paddock,
            distanceMiles: Math.round(distanceMiles)
          }
        })
        .sort((a, b) => a.distanceMiles - b.distanceMiles)
    }
  },

  created() {
    this.$store.dispatch('paddocks/fetchAll')
  },

  methods: {
    async fetchCurrentLocation() {
      this.isFetchingLocation = true

      try {
        const position = await getCurrentPosition()

        this.address.addressCoordinates = [position.coords.longitude, position.coords.latitude]

        this.$analytics.addEvent('Fetched geo location')

        this.$notify.success('Found you! Now showing paddocks nearest to you')
      } catch (error) {
        console.log('Error fetching position', error)

        this.$notify.error('Could not fetch your location, do you have it enabled?')
      }

      this.isFetchingLocation = false
    },

    async lookupPostcode() {
      this.address.error = null

      if (!this.address.postcode) {
        this.address.error = 'Please enter a postcode or click find me'
        return false
      }

      try {
        this.$analytics.addEvent('Postcode lookup')

        await this.$api.geo(this.address.fetchPostcodeApi).lookupPostcode(this.address.postcode)

        const coordinates = this.address.fetchPostcodeApi.response.data?.coordinates

        if (coordinates) {
          this.address.addressCoordinates = coordinates

          this.$notify.success('Found you! Now showing paddocks nearest to you')
        } else {
          throw new Error('No coordinates returned')
        }
      } catch (error) {
        this.address.hasLocation = false
        this.$log.error('Error fetching postcode', error)

        this.address.error = 'There was an error looking up that postcode, please try again'
      }
    }
  }
}
